import environment from 'environment';
import { getRequest } from '..';

const { BIG_COMMERCE_BASE_URL } = environment.eCommerce;

export const bigCommerceGetQuery = getRequest(BIG_COMMERCE_BASE_URL, {
  response: 60000, // Wait 60 seconds for the server to start sending,
  deadline: 70000, // but allow 70 seconds for the server to respond
});
